import { CommonActions, useNavigation } from '@react-navigation/core'
import React from 'react'
import { BackHeader } from '../../../../../assets/icons'
import { GetIcon } from '../../../../../ui/atoms/GetIcon'
import { Text, View } from 'react-native'
import { HEADER_HEIGHT } from '../..'
import { useTranslation } from 'react-i18next'

const backBehavior = (navigation) => {
  if (navigation.canGoBack()) {
    navigation.goBack()
  } else {
    navigation.dispatch({
      ...CommonActions.reset({
        index: 0,
        routes: [
          {
            name: 'More',
          },
        ],
      }),
    })
  }
}

export const Header = () => {
  const navigation = useNavigation()
  const { t } = useTranslation('global')
  return (
    <View
      style={{
        height: HEADER_HEIGHT,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#FFFFFF',
        paddingHorizontal: 20,
        borderBottomColor: '#F5F7F8',
        borderBottomWidth: 1,
      }}
    >
      <GetIcon
        icon={<BackHeader height="16" width="16" />}
        onPress={() => backBehavior(navigation)}
      />
      <Text style={{ fontWeight: '500', fontSize: 16 }}>
        {t('Wallet.header')}
      </Text>
      <View style={{ width: 40 }} />
    </View>
  )
}
